<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" persistent width="85%">
      <v-card>
        <v-card-title class="headline grey lighten-3" primary-title>
          <v-text-field v-model="name" label="Content Title"></v-text-field>
        </v-card-title>
        <v-card-text>
          <vue-editor v-model="description"></vue-editor>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="onCancel">Cancel</v-btn>
          <v-btn color="primary" text @click="onSave" :loading="saving" :disabled="saving">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import { CONTENT_UPDATE_MUTATION } from "../../../../constants/graphql";
export default {
  name: "ContentEditor",
  props: {
    content: {
      type: Object
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  components: {
    VueEditor
  },
  data() {
    return {
      name: this.content ? this.content.name : "",
      description: this.content ? this.content.description : "",
      dialog: this.show,
      saving: false
    };
  },
  watch: {
    show: function(val) {
      this.dialog = val;
    },
    content: function(content) {
      this.name = content.name;
      this.description = content.description;
    }
  },
  methods: {
    onCancel() {
      this.$emit("editCancel");
    },
    onSave() {
      if (this.content.id) {
        this.updateContent();
      }
    },
    updateContent() {
      this.saving = true;
      this.$apollo
        .mutate({
          mutation: CONTENT_UPDATE_MUTATION,
          variables: {
            id: this.content.id,
            name: this.name,
            description: this.description
          }
        })
        .then(data => {
          this.saving = false;
          this.$emit("contentSaved", data.data.updateContent);
        });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/gt/shared/contents/ContentEditor.vue